<script lang="ts">
	import {
		hoverState,
		hoveredXpos,
		hoveredYpos,
		originHoveredXpos,
		originHoveredYpos,
		selectedShapeIndex
	} from '../../stores/hover';
	import { CIRCLE_DIAMETER } from '../../utils/constants';
	import { COLS, ROWS, SymType } from '../../stores/settingsStore';
	import { gameStart, gameState } from '../../stores/winState';
	import { fade, fly } from 'svelte/transition';
	import { afterUpdate, onMount } from 'svelte';
	import { tweened } from 'svelte/motion';
	import { LightenDarkenColor } from '../../utils/colors';
	import renderBorder from '../../utils/renderBorder';
	import type { Collection, Element } from 'src/utils/types';
	import Socket from './Components/Socket.svelte';
	import ElementShadow from './Components/ElementShadow.svelte';
	import BackbgroundStripes from './Components/BackbgroundStripes.svelte';
	import { transitionToActive } from '../../stores/gameState';
	import LightningBar from '../../components/LightningBar.svelte';
	import Joint from './Components/Joint.svelte';

	export let collection: Collection;
	export let element: Element;
	export let shapeIndex = -1;
	export let mousedown: (index: number) => void = null;
	//export let onmouseout: (hoverState: boolean) => void;
	export let winState: () => void = null;
	//export let onmouseover: (index1: number, index2: number, x: number, y: number) => void;
	export let isItemSymemtrical: () => boolean = null;
	//export let changeVariantElement: () => void;

	const tweenLeft = tweened(0, {
		duration: 200
	});
	const tweenRight = tweened(0, {
		duration: 200
	});
	$: $tweenLeft = element.xpos * 50;

	//onMount(() => (initalizer = true));
	afterUpdate(() => {
		//collection.selected && console.log('rerender');
	});

	// function fadeScale(node, { delay = 0, duration = 400, baseScale = 0 }) {
	// 	const o = +getComputedStyle(node).opacity;
	// 	const m = getComputedStyle(node).transform.match(/scale\(([0-9.]+)\)/);
	// 	const s = (m ? m[1] : 1) as number;

	// 	return {
	// 		delay,
	// 		duration,
	// 		css: (t) => `opacity: ${t * o}; transform:scale(${t * s})`
	// 	};
	// }
</script>

<svelte:body
	on:mouseup={() => {
		$hoverState = false;
		winState();
		//console.log('off hover');
	}} />
<LightningBar isSymmetrical={isItemSymemtrical()} color={element.color} />
<!-- svelte-ignore a11y-mouse-events-have-key-events -->
{#if $gameStart && $transitionToActive}
	<div
		in:fade={{ delay: 2800 /* * (element.xpos / 200 + element.ypos / 10)*/ }}
		class="item-wrapper"
		style="
	      top:{element.ypos >= 5 && $SymType === 'Horizontal'
			? element.ypos * 50 + 2
			: element.ypos * 50}px; 
	      left:{element.xpos >= 3 && $SymType === 'Vertical'
			? element.xpos * 50 + 2
			: element.xpos * 50}px;"
		on:mousedown={() => {
			$hoverState = true;
			$originHoveredXpos = element.xpos;
			$originHoveredYpos = element.ypos;
			if ($selectedShapeIndex !== shapeIndex) {
				mousedown(shapeIndex);
				$selectedShapeIndex = shapeIndex;
			}
			//console.log('start hover');
		}}
	>
		<div
			in:fade={{ delay: 800 * (element.xpos / 200 + element.ypos / 10) }}
			class="item"
			style="
		background-color:{element.color}; 
		filter:saturate({collection.selected ? '130%' : '100%'});
		{renderBorder(collection, element, LightenDarkenColor(element.color, 60), 4)} "
		/>

		{#if !$hoverState}
			<div
				class="item-wrapper exit"
				style="
			display:{collection.selected ? 'block' : 'none'};
			z-index:100;
			background-color: {LightenDarkenColor(element.color, -100)};
			filter:saturate({collection.selected ? '130%' : '100%'});

			"
			/>
		{/if}

		{#if collection.selected}
			<!-- <div
				class="item-border"
				style=" 
		       
				box-shadow: inset 1px 0px 14px -5px rgba(0,0,0,0.59);
				filter:blur(3);
				{renderBorder(collection, element, LightenDarkenColor(element.color, 10), 6)} "
			/> -->
			<div class="item blinker" style="background-color:{LightenDarkenColor(element.color, -60)}" />
		{/if}

		<!-- this is the symmetrical indicator  -->
		<div
			class="symmetrical-item {element.ypos < $ROWS / 2 ? 'move-down' : 'move-up'}"
			style="display:{isItemSymemtrical && isItemSymemtrical() ? 'block' : 'none'};
                    left:{50 / 2 - CIRCLE_DIAMETER / 2}px;
                    top:{50 / 2 - CIRCLE_DIAMETER / 2}px;
                    width:{CIRCLE_DIAMETER}px;
                    height:{CIRCLE_DIAMETER}px;
                    background-color:{LightenDarkenColor(element.color, -60)};
                    z-index:100;
					filter:saturate({collection.selected ? '130%' : '100%'});

                     "
		/>

		<!--symmetry circular animation !! -->
		<div
			class="symmetrical-item {element.ypos < $ROWS / 2 ? 'move-down' : 'move-up'}"
			style="display:{isItemSymemtrical && isItemSymemtrical() ? 'block' : 'none'};
				   left:{50 / 2 - CIRCLE_DIAMETER / 2}px;
				   top:{50 / 2 - CIRCLE_DIAMETER / 2}px;
				   width:{CIRCLE_DIAMETER}px;
				   height:{CIRCLE_DIAMETER}px;
				   background-color:{LightenDarkenColor(element.color, -60)};
				   z-index:100;
				   filter:saturate({collection.selected ? '130%' : '100%'});
				  "
		/>
		<div
			class="indicator "
			style="display:{isItemSymemtrical && isItemSymemtrical() ? 'block' : 'none'};
				   left:{50 / 2 - CIRCLE_DIAMETER / 2}px;
				   top:{50 / 2 - CIRCLE_DIAMETER / 2}px;
				   width:{CIRCLE_DIAMETER}px;
				   height:{CIRCLE_DIAMETER}px;
				   border-left: 6px solid {LightenDarkenColor(element.color, -20)};
				   border-right: 6px solid {LightenDarkenColor(element.color, -20)};
				   z-index:101;
				   filter:saturate({collection.selected ? '130%' : '100%'});
				  "
		/>

		<!-- end symettrycal circle animation -->
		<Joint color={element.color} {collection} />
		<!-- <div
			class="symmetrical-item"
			style="left:{50 / 2 - CIRCLE_DIAMETER / 2}px;
			width:{CIRCLE_DIAMETER}px;
			height:{CIRCLE_DIAMETER}px;
			top:{50 / 2 - CIRCLE_DIAMETER / 2}px;
			border : {LightenDarkenColor(element.color, 60)} solid 4px;
			z-index:100;
			filter:saturate({collection.selected ? '130%' : '100%'});
			"
		/> -->

		<!-- render the socket-->
		<!-- {#if collection.selected} -->
		<Socket {collection} {element} />
		<!-- {/if} -->

		{#if collection.type === 'VARIANT' && element.color !== 'black'}
			<div class="variant-item" style="background-color:lightGreen;" />
		{/if}
	</div>
	<!-- {#if collection.selected}
		<ElementShadow {element} {collection} symmtery={$SymType} />
	{/if} -->
	<!-- <div
		class="item "
		style="
		top:{(element.ypos >= 5 && $SYMMETRY === 'HORIZONTAL' ? element.ypos * 50 + 5 : element.ypos * 50) +
			5}px; 
		left:{(element.xpos >= 3 && $SYMMETRY === 'VERTICAL' ? element.xpos * 50 + 5 : element.xpos * 50) +
			5}px;
		background-color:{LightenDarkenColor(element.color, -100)};
		z-index:1;
		"
	/> -->
{/if}

<style>
	.item-wrapper {
		position: absolute;
		width: 50px;
		height: 50px;
		overflow: hidden;
	}

	/* .item-fader {
		position: absolute;
		width: 50px;
		height: 50px;
		background: coral;
	} */
	.item {
		user-select: none;
		box-sizing: border-box;
		position: absolute;
		width: 50px;
		height: 50px;
		z-index: 2;
	}
	/* .background {
		user-select: none;
		width: 100%;
		height: 100%;
		background-color: darkgrey !important;
		z-index: 2;
	} */
	.symmetrical-item {
		user-select: none;
		box-sizing: border-box;
		position: absolute;
		top: 25px;
		width: 20px;
		height: 20px;
		border-radius: 20px;
		animation-duration: 400ms;
		animation-fill-mode: forwards;
		z-index: 3;
	}
	.indicator {
		user-select: none;
		box-sizing: border-box;
		position: absolute;
		top: 25px;
		width: 20px;
		height: 20px;
		border-left: 8px solid black;
		border-right: 8px solid black;
		border-radius: 20px;
		animation-name: rotater;
		animation-duration: 1s;
		animation-iteration-count: infinite;
		animation-fill-mode: both;
		animation-timing-function: linear;
		z-index: 40;
	}
	.move-down {
		animation-name: movedown;
	}

	.move-up {
		animation-name: moveup;
	}
	@keyframes movedown {
		from {
			top: -50px;
			transform: scale(1, 1);
		}
		to {
			top: 16px;
			transform: scale(1.4, 1.4);
			/*top: (50/2-18/2)px; */
		}
	}

	@keyframes rotater {
		from {
			transform: rotateZ(0deg);
		}
		to {
			transform: rotateZ(360deg);
		}
	}

	@keyframes moveup {
		from {
			top: 100px;
			transform: scale(1, 1);
		}
		to {
			top: 16px;
			transform: scale(1.4, 1.4);
		}
	}

	@keyframes fader {
		0% {
			transform: scale(1);
			opacity: 1;
		}
		90% {
			transform: scale(5);
			opacity: 0;
		}
		100% {
			transform: scale(1);
			opacity: 0;
		}
	}
	.blinker {
		animation-name: blink;
		animation-duration: 1s;
		animation-iteration-count: infinite;
		animation-fill-mode: both;
		animation-timing-function: linear;
	}
	@keyframes blink {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}

	.exit {
		animation-name: fader;
		animation-duration: 400ms;
		animation-fill-mode: forwards;
	}
	.variant-item {
		user-select: none;
		box-sizing: border-box;
		position: absolute;
		width: 50px;
		height: 50px;
		z-index: 5;
	}
</style>
